export function usePropostaTheme() {
  return {
    isDark: false,
    modalRootClassName: "proposta-modal",
    selectPopupClassName: "proposta-modal-dropdown--light",
  };
}
